import { useEffect } from "react";
import { StepId } from "v2/components/onboarding/types";
import { toStepKey } from "v2/constants/onboardingStepKey";
import {
  useGetOnboardingStateQuery,
  useSaveOnboardingStateMutation,
} from "v2/store/onboardingStateApi";
import { isAuthTokenPresent } from "./isAuthTokenPresent";

type SyncArgs = {
  doneSteps: StepId[];
  formationTypeId: string;
};

export const useSyncOnboardingState = ({
  doneSteps,
  formationTypeId,
}: SyncArgs): void => {
  const hasToken = isAuthTokenPresent();

  const { data: recorded } = useGetOnboardingStateQuery(undefined, {
    skip: !hasToken,
  });
  const [saveOnboardingState] = useSaveOnboardingStateMutation();

  const doneKeys = doneSteps.map(toStepKey);
  const recordedKeys = recorded?.completedSteps ?? [];

  const missingKeys = doneKeys.filter((key) => !recordedKeys.includes(key));
  const isFormationTypeMissing =
    Boolean(formationTypeId) && recorded?.formationTypeId !== formationTypeId;

  const pendingKeys = missingKeys.join(",");
  const shouldSync =
    Boolean(recorded) && (missingKeys.length > 0 || isFormationTypeMissing);

  useEffect(() => {
    if (!shouldSync) return;

    void saveOnboardingState({
      completedSteps: [...recordedKeys, ...missingKeys],
      formationTypeId: formationTypeId || recorded?.formationTypeId || "",
    });
  }, [shouldSync, pendingKeys, formationTypeId]); // eslint-disable-line react-hooks/exhaustive-deps
};
